import { createMemoryHistory } from 'history';

/**
 * Dedicated in-memory history for the trade-in activity.
 *
 * The trade-in flow (dr-activities-tradein) owns ABSOLUTE root-level routes
 * (e.g. /vehicleInfo, /tradeSummary) and navigates between steps via the router.
 * In sales-checkin the activity is mounted under the browser route /showroom/trade-in,
 * so letting trade-in drive the shared browser router would change the URL away from
 * the showroom and unmount its shell (sidebar, tabs).
 *
 * Mirroring Sales View (shopperPlatform runs activities on a createMemoryHistory),
 * we give trade-in its own in-memory routing space decoupled from the browser URL.
 * The Router in Root.tsx renders against this history, and tradeInRouterMiddleware
 * redirects trade-in route navigations into it.
 *
 * Seeded at /tradeIn so RootComponent's internal redirect lands on the correct step.
 */
export const tradeInHistory = createMemoryHistory({ initialEntries: ['/tradeIn'] });
